// import _ from 'lodash'
import vm from '../main'

const internals = {}

internals.addDevice = function(device) {
    device = (({
        brand,
        deviceModel,
        imei,
        connectionId,
        deviceId,
        status,
        dateAdded,
        deviceDescription
    }) => {
        return {
            brand,
            deviceModel,
            imei,
            connectionId,
            deviceId,
            status,
            dateAdded,
            deviceDescription
        }
    })(device)

    return vm.$deviceDataRepository
        .create(device)
        .then(result => {
            device = result.data
            return device
        })
        .catch(error => {
            console.error('deviceService.createRole-error:\n', error)
            throw error
        })
}

internals.updateDevice = function(device) {
    device = Object.assign({}, device)
    device = (({
        _id,
        brand,
        deviceModel,
        imei,
        connectionId,
        deviceId,
        status,
        dateAdded,
        deviceDescription
    }) => {
        return {
            _id,
            brand,
            deviceModel,
            imei,
            connectionId,
            deviceId,
            status,
            dateAdded,
            deviceDescription
        }
    })(device)

    return vm.$deviceDataRepository
        .update(device._id, device)
        .then(result => {
            device = result.data
            return device
        })
        .catch(error => {
            console.error('deviceUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/device.service.js